
 export const NumberFormatUtils = (value) => {
    return `${parseInt(value).toFixed(2)}`;
};

